/**
 * Quick 框架公共Json 处理方法
 * 版本:1.0.1
 * aibo:请同步修改UI公共库方法
 */
import { parse, getType, format, isArray, run } from './bll';

/**
 * 判断是否为json对象非json数组
 * @param {*} obj 初始对象
 */
const test = (obj) => {
  let isjson =
    typeof obj === 'object' &&
    Object.prototype.toString.call(obj).toLowerCase() === '[object object]' &&
    !obj.length;
  return isjson;
};

/**
 * json判断是空并且没有键值
 * @param {*} json 支持 null
 * @returns true
 */
const isNull = (json) => {
  if (json) {
    for (let key in json) {
      return false;
    }
  }
  return true;
};

/**
 * 判断是否标准json字符串
 * @param {*} string Json 双引号字符串
 * JSON.parse
 */
const isString = (string) => {
  try {
    // if(getType(string)!='string'){
    //    throw new Error('isString.'+getType(string))
    // }
    JSON.parse(string);
    return true;
  } catch (error) {
    return false;
  }
};

/**
 * 转换为字符串
 * @param {*} o
 * @param {*} callback 回调处理
 *  @param {*} opts 附加参数：制表符 \t
 * JSON.stringify
 */
const toString = (o, callback, opts) => {
  if (callback) {
    return JSON.stringify(o, callback, opts);
  } else {
    return JSON.stringify(o);
  }

  // console.log('toString:' + norm, getType(o), o);

  // if (isArray(o)) {
  //   // 数组
  //   let r = [];
  //   r[0] = '[';
  //   for (let i = 0; i < o.length; i++) {
  //     r[r.length] = toString(o[i], norm);
  //     if (i < o.length) {
  //       r[r.length] = ',';
  //     }
  //   }
  //   if (r.length > 1) {
  //     // 去除结束,
  //     r[r.length - 1] = ']';
  //   } else {
  //     r[r.length] = ']';
  //   }

  //   return r.join('');
  // } else {
  //   // 当前对象类型
  //   switch (typeof o) {
  //     case 'object':
  //       // 创建转换格式
  //       let r = [];
  //       for (let p in o) {
  //         console.log('p:' + p, getType(o[p]));
  //         // 字段名称
  //         r[r.length] = ',"' + p + '":';
  //         r[r.length] = toValue(o[p], norm);
  //       }

  //       r = r.join('');
  //       if (r.length > 0) {
  //         r = '{' + r.substr(1) + '}';
  //       }
  //       return r;
  //     default:
  //       return o;
  //   }
  // }
};

/**
 * 对象转字符串
 * @param {*} o json
 * @param {*} callback 回调处理(k,v,index)
 */
const toFrom = (o, callback) => {
  // console.log('toFrom:', test(o), o);
  if (!test(o)) {
    throw new Error('toFrom is not json ' + getType(o));
  }

  callback =
    callback ||
    function (key, value, index) {
      let _mark;
      if (index > 0) {
        // 加上分割符号
        _mark += ',';
      }
      return _mark + '"' + key + '":' + toValue(value);
    };

  let _json = '';
  let _int = 0;
  for (let prop in o) {
    // console.log('toFrom', prop, o[prop], _int);
    _json += callback(prop, o[prop], _int);
    _int++;
  }

  return _json;
};

/**
 * json 值转换输出
 * @param {*} val 值
 * @param {*} type 指定类型，默认为空getType(val)
 */
const toValue = (val, type) => {
  type = type || getType(val);
  // console.log('toValue',type, val);
  // 非对象数组
  switch (type) {
    case 'string':
      val = '"' + val + '"';
      break;
    case 'date':
      // 时间格式
      val = '"' + format('yyyy-MM-dd hh:mm:ss', val) + '"';
      break;
    case 'array':
    case 'object':
      val = JSON.stringify(val);
      break;
  }

  return val;
};

/**
 * 将Json数据转换为URL编码
 * @param {*} object 初始json对象
 * @param {*} isEncoded 是否转码 encodeURIComponent
 * 返回 key=val&key2=val2
 */
const toUrl = (object, isEncoded) => {
  // console.log('url:', test(object), object);
  if (!test(object)) {
    return;
  }

  return toFrom(object, function (key, value, index) {
    let _mark = '';
    if (index > 0) {
      // 加上分割符号
      _mark += '&';
    }
    // 转换值内容
    value = toValue(value);
    // 是否转码
    if (isEncoded) {
      value = encodeURIComponent(value);
    }

    return _mark + key + '=' + value;
  });

  // let encodedString = '';

  // for (let prop in object) {
  //   //  if (object.hasOwnProperty(prop)) {
  //   if (encodedString.length > 0) {
  //     encodedString += '&';
  //   }

  //   // 取出对象
  //   let val = object[prop];
  //   // console.log('url:' + prop, val);
  //   val = toValue(val);

  //   // 是否转码
  //   if (isEncoded) {
  //     encodedString += prop + '=' + encodeURIComponent(val);
  //   } else {
  //     encodedString += prop + '=' + val;
  //   }
  // }
  // return encodedString;
};

/**
 * 转为style 样式
 * @param {*} o
 */
const toStyle = (o) => {
  return toFrom(o, function (key, value, index) {
    //console.log('toStyle', key, value, index);
    return key + ':' + value + ';';
  });
};

/**
 * 将url参数格式转为json
 * @param {*} str 需格式的str
 * url格式如：?1=默认&2=网关&3=光纤
 * 返回 json.from(str,/([^?&]+)=([^?&]+)/g)
 */
const fromUrl = (str) => {
  return from(str, /([^?&]+)=([^?&]+)/g);
};

/**
 * 将样式转为json
 * @param {*} str 样式字符串
 *  返回 json.from(str,/([^;]+):([^;]+);/g)
 */
const fromStyle = (str) => {
  return from(str, /([^;]+):([^;]+);/g);
};

/**
 * 字符串正则转为json
 * @param {string} str 初始字符串
 * @param {*} param 自定义正则
 * @param {*} isEncoded 默认不转码 encodeURIComponent
 */
const from = (str, param = /([^?&]+)=([^?&]+)/g, isEncoded = false) => {
  let _json = {};
  str = str.replace(param, function (s, k, v) {
    // s全部
    // console.log('s:' + s, 'k:' + k, 'v:' + v);
    if (isEncoded) {
      _json[k] = decodeURIComponent(v);
    } else {
      _json[k] = v;
    }
    return k + '=' + v;
  });

  // console.log('from', str);
  return _json;
};

/**
 * 深度拷贝 DeepCopy
 * @param {*} json 初始值
 * 返回新对象
 */
const copy = (json) => {
  return JSON.parse(JSON.stringify(json));
};

/**
 * 异步查找Json数组并且回调，默认返回第一条
 * @param {*} option 查找条件
 * {data:查找数组,where:查找的条件,subs:查找子项关键字,where,callback}
 * where:'data.ID===9 && data.Title==="abc"'
 * callback(对象,level:层次,序号){ //return -1;取出全部}
 */
const find = (option) => {
  // 查找层级
  option.level = option.level || 0;
  // 顶层结束标记
  option.flag = option.flag || 0;

  // 是否结束查找
  option.end =
    option.end ||
    function (obj, level, i) {
      //  console.log('end', level, i, option.data.length, obj);
      if (obj) {
        // 找到了与key匹配的节点,进行回调，若回调返回-1 将继续查找，直到结束
        option.flag = option.callback(obj, level, i) || 1;
        //  console.log('end.flag', option.flag);

        // return;
      } else {
        if (level == 1 && option.data.length == i) {
          // 查询结束
          option.callback(null, level, i);
        }
      }
    };

  // 查询数据
  if (!option.data) {
    // 数据空不报错
    return null;
  }

  // 查询条件
  if (!option.where) {
    throw new Error('option.where is null ' + option.level);
  }

  //层级递进
  option.level++;
  // console.log('level:', option.level);

  // 1.第一层 root 深度遍历整个JSON
  for (let i = 0; i < option.data.length; i++) {
    if (option.flag == 1) {
      //已经找到，结束循环
      return;
    }

    // console.log('level:', option.level, option.flag);

    // 取出当前对象
    let _obj = option.data[i];
    if (!_obj) {
      // 对象为空 跳出当前,继续查询
      continue;
    }

    // console.log(option.level + ':' + i, option.where, JSON.stringify(_obj));

    // 判断当前内容是否符合
    let _resp = false;
    try {
      _resp = run(
        'if(' + option.where + '){return true}else{return false}',
        'data',
        _obj
      );
    } catch (e) {
      throw new Error('option.where : ' + option.where);
    }
    //console.log(option.level + ':' + i, option.where,_resp);

    if (_resp) {
      // 找到 结束递归
      option.end(_obj, option.level, i);
    } else if (option.subs && isArray(_obj[option.subs])) {
      // 递归往下找
      find({
        level: option.level,
        data: _obj[option.subs],
        subs: option.subs,
        where: option.where,
        callback: option.callback,
        end: option.end,
        flag: option.flag
      });
    }
  }

  option.end(null, option.level, option.data.length);
};

/**
 * 异步查找Json数组并且回调，取出全部,并返回层次与序号
 * @param {*} option 查找条件
 * {data:查找数组,where:查找的条件,subs:查找子项关键字,where,callback}
 * where:'data.ID===9 && data.Title==="abc"'
 * callback([对象数组],[level:层次,index:序号]){}
 */
const findAll = (option) => {
  let _rt = [];

  let _leve = [];
  // 缓存传入方法
  const _callback = option.callback;

  option.callback = (obj, level, index) => {
    // console.log('k:' + level, index, JSON.stringify(obj));

    if (obj) {
      _rt.push(obj);
      _leve.push({ level, index });
    } else {
      _callback(_rt, _leve);
    }

    // 继续查找
    return -1;
  };

  find(option);

  // // 1.第一层 root 深度遍历整个JSON
  // for (let i = 0; i < option.json.length; i++) {
  //   let props = option.json[i];
  //   if (option.where) {
  //     // let _where = bind(props, option.where)
  //     // let _where = 'props.ID===1 && props.Title==="abc2"'
  //     // console.log(option.where)
  //     let _obj = new Function(
  //       'props',
  //       'if(' + option.where + '){return props}else{return null}'
  //     )(props);
  //     //  console.log(_obj)
  //     if (_obj) {
  //       // }

  //       // 判断当前内容是否符合
  //       //  if (obj[option.key] === option.val) {
  //       // 找到了与key匹配的节点，结束递归
  //       _rt.push({
  //         index: i,
  //         obj: props,
  //       });

  //       if (option.callback) {
  //         option.callback(props, i);
  //       }
  //     }
  //   }
  // }
  // return _rt;
};

/**
 * 模板与Json 数据绑定
 * @param {*} json 绑定的数据{user,name}
 * @param {*} template 绑定的模板 <ul><li>{user}</li><li>{name}</li></ul>
 */
const bind = (json, template) => {
  // 正则
  return template.replace(/{(.*?)}/gim, function ($, $1) {
    let _val = json[$1]; // 取出Json值
    // console.log($ + ',' + $1 + ',' + _val + ',' + typeof _val)
    // if (quick.bll.isNull(_val)) {
    // 获取内容，判断为空，直接返回值
    // switch (typeof _val) {
    //   case 'boolean':
    //     _val = 'false'
    //     break
    //   case 'number':
    //     _val = 0
    //     break
    //   default:
    //     _val = ''
    //     break
    // }
    //}
    return _val;

    //  return data[$1] ? data[$1] : data[$1] ? data[$1] == "" ? def : $ : def;
  });
};

/**
 * 对象转换为数组
 * @param {*} json json对象
 * @param {*} callback 回调处理方法(val,key,json)
 */
const map = (json, callback) => {
  let index = -1;
  const result = new Array();
  for (let p in json) {
    index++;
    result[index] = callback(json[p], p, json);
  }
  return result;
};

/**
 * 转为Json树结构
 * @param {*} json 对象
 * 返回 map数组
 */
const makeTree = (json) => {
  //  console.log(json, 'json');
  return map(json, (val, key) => {
    // 返回树节点
    const leaf = {
      key: key,
      type: getType(val),
      value: null,
      children: null
    };

    if (val === null || typeof val !== 'object') {
      // 直接赋值
      leaf.value = val;
    } else {
      // 值对象为数组，转为树节点
      leaf.children = makeTree(val);
    }
    return leaf;
  });
};

/**
 * json格式化换行显示
 * @param {string,object} value json文本内容支持非标
 * @param {*} space  缩进的数量,默认2
 * @returns parseOne
 */
const makeFormat = (value, space) => {
  space = space || 2;
  if (typeof value == 'string') {
    //支持非标 转换
    return JSON.stringify(parseOne(value), space);
  } else {
    return JSON.stringify(value, null, space);
  }
};

/**
 * 双引号与非标单引号字符串转换对象，去除换行
 * @param {string} jsonStr 双引号与非标单引号文本内容
 * 返回 bll.parse(str)
 */
const parseOne = (jsonStr) => {
  //console.log(typeof jsonStr, jsonStr);
  if (typeof jsonStr != 'string') {
    return jsonStr;
  }
  jsonStr = jsonStr.replace(/\n(\s*)/g, ''); // 去换行
  return parse(jsonStr);
};

export {
  test,
  isNull,
  isString,
  toString,
  toFrom,
  toValue,
  toStyle,
  toUrl,
  fromUrl,
  fromStyle,
  from,
  find,
  findAll,
  copy,
  bind,
  map,
  makeTree,
  makeFormat,
  parseOne
};
